import React from 'react';

const IconTicket3: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.7297 11L39.9879 14.9388L36.7973 19.0387L41.6818 20.4856L37.2624 23.1382L43 24.7461L38.5138 28.6044L41.9921 30.9357L37.9603 32.9455L39.9879 36L7.10147 35.5981L9.81528 31.4983L4 30.6945L7.64412 26.3537L4 23.5L9.42764 19.923L4.38765 17.0289L11.4435 15.18L8.7297 11Z" fill="#43D685" />
  </svg>
);

export default IconTicket3;
